import { render, staticRenderFns } from "./AddInventoryForm.vue?vue&type=template&id=da2e8f34&scoped=true&lang=pug"
import script from "./AddInventoryForm.vue?vue&type=script&lang=js"
export * from "./AddInventoryForm.vue?vue&type=script&lang=js"
import style0 from "./AddInventoryForm.vue?vue&type=style&index=0&id=da2e8f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2e8f34",
  null
  
)

export default component.exports